/* src/app/support/shell/file-download-dialog/file-download-dialog.component.css */
mat-form-field {
  margin-bottom: 16px;
}
/*# sourceMappingURL=file-download-dialog.component.css.map */
